import { translations as en } from "./en";
import { translations as ru } from "./ru";

const loadTranslation = (translations: any[]) => {
  const result = {};

  translations.forEach(translation => {
    result[translation.messageId] = translation.text;
  });

  return result;
};

export const translations = {};
translations[en.locale] = loadTranslation(en.values);
translations[ru.locale] = loadTranslation(ru.values);
